import React from 'react';
import { AddEmployeesTable } from 'components/rfq/initiate-rfq/initiate-add-employees/AddEmployeesTable';
import PageFooter from 'components/common/general/layouts/PageFooter';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { observer } from 'mobx-react-lite';
import InitiateAddEmployeesPageStore, {
  InitiateAddEmployeesPageStoreContext,
  useInitiateAddEmployeesPageStore,
} from 'store/pages/rfq/initiate-add-employees/pageStore';
import { TableManagementPanel } from 'components/rfq/initiate-rfq/initiate-add-employees/TableManagementPanel';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { onBack, onComplete, stepCanComplete } = useInitiateAddEmployeesPageStore();

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.INITIATE_ADD_EMPLOYEES.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.INITIATE_ADD_EMPLOYEES.text}
        subtitleMaxWidth="42rem"
        onRedirect={onBack}
      />
      <TableManagementPanel />
      <AddEmployeesTable />
      <PageFooter onBack={onBack} onComplete={onComplete} disableCompleteButton={!stepCanComplete} />
    </>
  );
});

const InitiateAddEmployeesPage: React.FC = observer(() => {
  const { periodId, cartId, groupId } = useEnrollmentQuoteUrlParams();

  return (
    <RFQStatusLayout>
      <InitiateAddEmployeesPageStoreContext.Provider
        value={new InitiateAddEmployeesPageStore({ groupId, cartId, periodId })}
      >
        <PageContent />
      </InitiateAddEmployeesPageStoreContext.Provider>
    </RFQStatusLayout>
  );
});

export default InitiateAddEmployeesPage;
